module.exports = "/images/icono-covid.png?b0a9896ee0a9df8766b0fe87e0b0cba1";